import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
export const trackerGet = (path, params) => axios.get(`${API_URL}/api/brand-tracker${path}`, { params, withCredentials: true }).then((r) => r.data);
export const adminApi = {
  get: (p) => axios.get(`${API_URL}/api/brand-tracker${p}`, { withCredentials: true }).then((r) => r.data),
  post: (p, b) => axios.post(`${API_URL}/api/brand-tracker${p}`, b, { withCredentials: true }).then((r) => r.data),
  put: (p, b) => axios.put(`${API_URL}/api/brand-tracker${p}`, b, { withCredentials: true }).then((r) => r.data),
  scrape: (id, force = false) => axios.post(`${API_URL}/api/brand/scrape/${id}`, {}, { params: { force }, withCredentials: true }).then((r) => r.data),
};

export const ORANGE = '#FF451A';
export const PALETTE = ['#FF451A', '#FF8A5B', '#C2410C', '#FDBA8C', '#9A3412', '#FFD4BF'];
export const TIER_ORDER = ['Nano', 'Micro', 'Macro', 'Mega'];
export const TYPE_LABEL = { reel: 'Reel', static: 'Static', story: 'Story' };

export const compact = (n) => (n == null ? '—' : n >= 1e6 ? `${(n / 1e6).toFixed(1)}M` : n >= 1e3 ? `${(n / 1e3).toFixed(n >= 1e5 ? 0 : 1)}K` : String(n));
export const dateShort = (iso) => (iso ? new Date(iso).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }) : '—');
export const dateTime = (iso) => (iso ? new Date(iso).toLocaleString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—');
export const errMsg = (e, f) => (typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : f);

export const CARD = 'bg-white border border-black/[0.07] rounded-2xl shadow-[0_1px_2px_rgba(0,0,0,0.03)]';
